// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalForm_wrapper__paURB","title":"ModalForm_title__nPZuo","description":"ModalForm_description__nZaiG"};